// extracted by mini-css-extract-plugin
export default {"root":"ReactionEmoji-module__root","selected":"ReactionEmoji-module__selected"};